import { Box, Button, IconButton, Stack, Typography } from "@mui/material"
import { styles } from "./styles/PayLicenseAlert.styles"
import { useAuthContext } from "contexts/AuthContext"
import { useLicenceContext } from "contexts/LicenceContext"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"

const smashyImg = require("assets/img/auth/smashy-01.gif")
const smashorImg = require("assets/img/auth/smasher-01.gif")

export default function PayLicenseAlert({ onClose }) {
  const { t } = useTranslation()
  const { accountType } = useAuthContext()
  const { licenceDaysLeft, openInvoice } = useLicenceContext()

  const daysMessageParts = t("temporal_license_message_daysleft").split(
    "<strong>{0}</strong>"
  )

  const HighlightedDays = ({ value }) => (
    <Box component="span" sx={{ fontWeight: 900, color: "#ff2523" }}>
      {value}
    </Box>
  )

  return (
    <Box sx={[styles.alert]}>
      <Stack alignItems={"center"} p={1} position={"relative"}>
        <IconButton sx={styles.closeButton} onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <Stack direction={"row"} sx={styles.content}>
          <Box
            component="img"
            src={accountType < 7 ? smashyImg : smashorImg}
            alt="Smashy Character"
            sx={styles.smashyCharacter}
          />
          <Typography variant="span" sx={styles.message} fontSize={16}>
            {daysMessageParts[0]}
            <HighlightedDays value={licenceDaysLeft} />
            {daysMessageParts[1]}
          </Typography>
        </Stack>
        <Button
          variant="contained"
          disableElevation
          sx={styles.button}
          onClick={openInvoice}
        >
          {t("pay_now")}
        </Button>
      </Stack>
    </Box>
  )
}
